exports.KnobModule = require('./lib/knob.module').KnobModule;
exports.KnobComponent = require('./lib/knob.component').KnobComponent;



//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/ng2-knob/index.js
// module id = ../../../../ng2-knob/index.js
// module chunks = vendor